import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/reagendamento-cancelamento-exame`

    return {
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        getJornadas(queryParms) {

            return repository.get(`${baseUrl}/jornada?${urlUtil.serialize(queryParms)}`)
        },
        getPrestadores(queryParms) {

            return repository.get(`${baseUrl}/prestador?${urlUtil.serialize(queryParms)}`)
        },
        getGrupos(queryParms) {

            return repository.get(`${baseUrl}/grupo?${urlUtil.serialize(queryParms)}`)
        },
        getJornadasDestino(queryParms) {

            return repository.get(`${baseUrl}/jornada-destino?${urlUtil.serialize(queryParms)}`)
        },
        reschedule(params) {
            return repository.put(`${baseUrl}/reschedule`, params)
        },
        cancel(params) {
            return repository.put(`${baseUrl}/cancel`, params)
        },
    }
}